import axios from "axios";

export const trainPoTemplateSample = async (customerId, file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`customer/${customerId}/po-template/train-sample`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const savePoTemplate = async (customerId, payload) => {
  const { data } = await axios.post(`customer/${customerId}/po-template`, payload);
  return data;
};

export const listPoTemplates = async (customerId) => {
  const { data } = await axios.get(`customer/${customerId}/po-templates`);
  return data;
};

export const getPoTemplate = async (templateId) => {
  try {
    const { data } = await axios.get(`customer/po-template/${templateId}`);
    return data;
  } catch (err) {
    if (err?.response?.status === 404) return null;
    throw err;
  }
};

export const deletePoTemplate = async (templateId) => {
  const { data } = await axios.delete(`customer/po-template/${templateId}`);
  return data;
};
